import { defineComponent as _defineComponent } from 'vue'
interface Props {
	content: any;
	top: string;
	left: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'packageDetalisPopUp',
  props: {
    content: { default: [""] },
    top: { default: "30px" },
    left: { default: "30px" }
  },
  setup(__props: any) {

const props = __props as { content: any, top: string, left: string }



return { __sfc: true,props }
}

})